var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-shell"},[_c('site-header'),_c('main',{staticClass:"site-main"},[_c('router-view')],1),_c('site-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }